import { createAppSelector, selectTerms } from "./base";
import { selectSectionUsersForCurrentUser } from "./section-user";
import { sortByTermYearRegex } from "./sorting";

export const selectSortedTerms = createAppSelector([selectTerms], (terms) =>
  terms.toSorted(sortByTermYearRegex),
);

export const selectSortedTermsForCurrentUser = createAppSelector(
  [selectSectionUsersForCurrentUser, (state) => state.sections, (state) => state.terms],
  (sectionUsers, sectionMap, termMap) => {
    const sectionIds = new Set(sectionUsers.map((cu) => cu.section_id));
    const termIds = new Set(
      Array.from(sectionIds).flatMap((sectionId) => {
        const section = sectionMap[sectionId];
        return section ? [section.term_id] : [];
      }),
    );
    return Array.from(termIds)
      .flatMap((termId) => {
        const term = termMap[termId];
        return term ? [term] : [];
      })
      .toSorted(sortByTermYearRegex);
  },
);
